/* promise/index */ function _(require, module, exports) {
    module.exports = require(282) /* ./lib */;
}
